var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"chartProtocoleLibre",attrs:{"height":"200px","width":"1000px"}}),_c('p',{staticClass:"is-margin-b-20 has-text-centered has-text-weight-semibold"},[_vm._v(" "+_vm._s(_vm.$t("datesDepuisPremierExoLibreRealise"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }